import React, { useState } from "react";
import toast from "react-hot-toast";
import Button from "../UI/Button";
import { apiUrl } from "../../config/api";
import { useNavigate } from "react-router-dom";

export default function ResetPassword() {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") || "";

  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

const submit = async (e) => {
  e.preventDefault();

  const toastId = "reset-password";

  if (!token) {
    toast.error("Missing reset token.");
    return;
  }

  if (pw.length < 8) {
    toast.error("Password must be at least 8 characters.");
    return;
  }

  if (pw !== pw2) {
    toast.error("Passwords do not match.");
    return;
  }

  try {
    setLoading(true);
    toast.loading("Updating password...", { id: toastId });

    const res = await fetch(apiUrl("/api/password/reset"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, newPassword: pw }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || "Reset failed");

    toast.success("Password updated successfully!", { id: toastId });

    setTimeout(() => {
      navigate("/login");
    }, 1200);
  } catch (err) {
    console.error(err);
    toast.error(err.message || "Reset failed", { id: toastId });
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950 p-6">
      <div className="w-full max-w-md bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-3xl p-8 shadow-xl">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Reset Password</h1>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          Set a new password for your account.
        </p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-semibold text-gray-700 dark:text-gray-200">New password</label>
            <input
              type="password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="mt-2 w-full h-11 rounded-xl border border-gray-200 dark:border-gray-800 px-4 bg-white dark:bg-gray-900"
              placeholder="At least 8 characters"
              required
            />
          </div>

          <div>
            <label className="text-sm font-semibold text-gray-700 dark:text-gray-200">Confirm password</label>
            <input
              type="password"
              value={pw2}
              onChange={(e) => setPw2(e.target.value)}
              className="mt-2 w-full h-11 rounded-xl border border-gray-200 dark:border-gray-800 px-4 bg-white dark:bg-gray-900"
              placeholder="Repeat password"
              required
            />
          </div>

          <Button type="submit" loading={loading} className="w-full">
            Update password
          </Button>
        </form>
      </div>
    </div>
  );
}